import { useEffect } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';

import { useSelector, useDispatch } from '@app/hooks';

import { PageFallback } from '../../../../layout';
import { PageError } from '../../../segments';
import { useAuth, useGetAuthInstance } from '../../../hooks';
import { AuthRouterService } from '../../../services';
import {
  verifyOpenIdToken,
  selectStage,
  selectNotification,
} from '../../../slice';

export const Login = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useAuth();
  const step = useSelector(selectStage);
  const router = useInject(AuthRouterService);
  const error = useSelector(selectNotification);
  const authInstance = useGetAuthInstance();

  useEffect(() => {
    if (isAuthenticated) {
      router.redirectToSaved();
    }
  }, [isAuthenticated, router]);

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(
        verifyOpenIdToken({
          authInstanceId: authInstance.id,
        }),
      );
    }
  }, [isAuthenticated, dispatch, authInstance.id]);

  if (step === 'error') {
    return <PageError theme="oauth2" error={error} />;
  }

  return <PageFallback />;
};
